import { Box, Typography, useTheme } from "@mui/material"
import { useSetRecoilState } from "recoil";
import { contextDialogAtom } from "../atoms/dialogContext";
import { CtxUfficioCorrenteType, useUserContextView } from "../atoms/portale";
import { User } from "../models";
import ContextIcon from "../svgicons/ContextIcon";

const ContextSelector = () => {
    const { user, userCtx } = useUserContextView()
    const setOpenDialog = useSetRecoilState(contextDialogAtom)
    const isAzienda = user?.role === 'azienda'

    const handleSetupContext = () => {
        // console.log('handleSetupContext')
        setOpenDialog({ show: true })
    }

    // Allo stato attuale delle cose il contesto dell'azienda non è impostabile
    // Unica possibilità quando un utente ha più codici aziendali per cui è 
    // costretto ad uscire e rientrare con il nuovo codice (no big thing)
    const handleSetupContextAzienda = () => {
        // console.log('handleSetupContextAzienda')
        alert(`Utente Aziendale, il contesto non e' impostabile`)
    }

    if (!user || !userCtx) return null;

    return (
        <>
            <Box sx={{ flexGrow: 0, width: 'auto', margin: 0, display: 'flex', alignItems: 'center', gap: 2 }}>
                {isAzienda
                    ? <ContextViewerAzienda user={user} userCtx={userCtx} onSetupContext={handleSetupContextAzienda} />
                    : <ContextViewerDefault user={user} userCtx={userCtx} onSetupContext={handleSetupContext} />
                }
            </Box>
        </>
    )
}
export default ContextSelector

type ContextViewerPropsType = { user: User, userCtx: CtxUfficioCorrenteType, onSetupContext: () => void }

//const ContextViewerAzienda = ({ user, userCtx, onSetupContext }: ContextViewerPropsType) => {
const ContextViewerAzienda = ({ user }: ContextViewerPropsType) => {
    const codice = user.claims?.find(x => x.type === 'sx.co')?.value ?? 'No Code'
    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', aligntItems: 'center' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                    <Typography variant='body1' color='#EDEFF0' sx={{ fontWeight: 800 }}>{user.name}</Typography>
                </Box>
                <Typography variant='body2' color='#EDEFF0' sx={{ fontWeight: 800 }}>{codice} - {user.context?.descriCodice}</Typography>
            </Box>
            {/* <Typography variant='body1' color='default' sx={{ fontWeight: 800 }}>&nbsp;</Typography>
            <Box sx={theme => ({ cursor: 'pointer', height: '27px', color: theme.palette.primary.main })} onClick={onSetupContext}><ContextIcon color='#1e88e5' /></Box> */}
        </>
    )
}

const ContextViewerDefault = ({ user, userCtx, onSetupContext }: ContextViewerPropsType) => {
    const { palette } = useTheme();
    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', aligntItems: 'center' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                    <Typography variant='body1' color='#EDEFF0' sx={{ fontWeight: 800 }}>{user.name}</Typography>
                    <Typography variant='body2' color='#EDEFF0'><small><em>({userCtx.ufficioCorrente})</em></small></Typography>
                </Box>
                <Typography variant='body2' color='#EDEFF0' sx={{ fontWeight: 800 }}>{userCtx.provSel.descrizione} - {userCtx.uffiSel.descrizione}</Typography>
            </Box>
            <Typography variant='body1' color='#EDEFF0' sx={{ fontWeight: 800 }}>{userCtx.ambiSel.label}</Typography>
            <Box sx={theme => ({ cursor: 'pointer', height: '27px', color: theme.palette.primary.main })} onClick={onSetupContext}>
                {/* <ContextIcon color={palette.primary.main} /> */}
                <ContextIcon color="#EDEFF0" />
            </Box>
        </>
    )
}
